<template>
  <div class="serial-input">

    <b-input-group prepend="Serial number" sm="4">
      <b-form-input v-model="mySerialNumber"></b-form-input>
      <b-input-group-append>
        <b-button variant="info" v-on:click="updateSerialNumber">Update</b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>
<script>

export default {
  name: "SerialInput",
  data: function() {
    return {
      mySerialNumber: "205A414246303031353837303938363131"
    };
  },
  methods: {
    updateSerialNumber: function() {
      this.$root.$emit("updateSerialNumber", this.mySerialNumber);
      location.href='#electricity';
    }
  }
};
</script>
<style>
.serial-input{
  width: 560px;
  margin: 50px auto;
}
</style>
